import React, { useState } from "react";
import { bool, func, shape, string } from "prop-types";
import { Field } from "formik";
import Button from "pages/_components/Button";
import { useDispatch } from "react-redux";
import Drawer from "pages/_components/Drawer/Drawer";
import TableFrequentDestination from "pages/frequentDestination/_components/TableFrequentDestination";
import SwitchField from "pages/_components/fields/formik/SwitchField";
import { actions as echeckActions } from "reducers/echecks";
import Avatar from "pages/_components/Avatar";
import GridTable from "pages/_components/GridTable/GridTable";
import AddBeneficiary from "./AddBeneficiary";

const FORM_ID = "echeqs.emit";

const Beneficiaries = ({ isDesktop, idForm, setEmailValues, beneficiaryData, actionType }) => {
    const dispatch = useDispatch();

    const [openSidebarList, setOpenSidebarList] = useState(false);
    const [openSidebarForm, setOpenSidebarForm] = useState(false);

    const selectBeneficiary = (beneficiary) => {
        if (setEmailValues) {
            setEmailValues("email", beneficiary?.email);
        }
        dispatch(
            echeckActions.beneficiaryEcheq(
                {
                    document:
                        beneficiary?.document ||
                        `${beneficiary?.recipientDocumentType} ${beneficiary?.recipientDocumentNumber}`,
                    reference: beneficiary?.headline || beneficiary?.recipientName,
                    email: beneficiary?.email,
                },
                actionType,
            ),
        );

        setOpenSidebarList(false);
    };

    const cleanBeneficiary = () => {
        if (setEmailValues) {
            setEmailValues("sendEmail", false);
            setEmailValues("email", "");
            setEmailValues("emailText", "");
        }
        dispatch(echeckActions.beneficiaryEcheq({}, actionType));
    };

    return (
        <>
            <GridTable className="echeck beneficiaries">
                <GridTable.Container columns={12} columnsTemplate="fixed" className="mb-4">
                    <GridTable.Data columnStart={1} columnWidth={isDesktop ? 4 : 12} rowStart={1}>
                        <Button
                            className="btn-outline px-2"
                            label="echecks.search.contact"
                            onClick={() => setOpenSidebarList(true)}
                        />
                    </GridTable.Data>
                    <GridTable.Data
                        columnStart={isDesktop ? 5 : 1}
                        columnWidth={isDesktop ? 4 : 12}
                        rowStart={isDesktop ? 1 : 2}>
                        <Button
                            className="btn-outline px-2"
                            label="echecks.new.contact"
                            onClick={() => setOpenSidebarForm(true)}
                        />
                    </GridTable.Data>
                    {setEmailValues && (
                        <GridTable.Data>
                            <Field component={SwitchField} idForm={idForm} name="sendEmail" />
                        </GridTable.Data>
                    )}
                </GridTable.Container>
                {beneficiaryData?.beneficiary?.reference && (
                    <GridTable.Container className="beneficiary box border blocktag mb-4">
                        <GridTable.Data columnStart={1} columnWidth={1}>
                            <Avatar
                                user={{
                                    userFullName: beneficiaryData?.beneficiary?.reference,
                                    defaultAvatarId: 0,
                                    email: beneficiaryData?.beneficiary?.email,
                                }}
                            />
                        </GridTable.Data>
                        <GridTable.Data columnStart={2} columnWidth={9} alignY="center">
                            <b className="primary">{`${beneficiaryData?.beneficiary?.reference}`}</b>
                        </GridTable.Data>
                        <GridTable.Data columnStart={12} columnWidth={1} className="close" alignX="end" alignY="center">
                            <Button
                                onClick={() => cleanBeneficiary()}
                                image="images/figma/icon/cross.svg"
                                bsStyle="link close"
                                block={false}
                            />
                        </GridTable.Data>
                    </GridTable.Container>
                )}
            </GridTable>
            <Drawer openSidebar={openSidebarList} toggleSidebar={setOpenSidebarList}>
                <TableFrequentDestination
                    formId={FORM_ID}
                    onRowClick={selectBeneficiary}
                    searchClassName="d-flex flex-column"
                    isDesktop={isDesktop}
                    fromModal
                />
            </Drawer>
            <Drawer openSidebar={openSidebarForm} toggleSidebar={setOpenSidebarForm}>
                <AddBeneficiary type={actionType} setOpenSidebarForm={setOpenSidebarForm} />
            </Drawer>
        </>
    );
};

Beneficiaries.propTypes = {
    isDesktop: bool.isRequired,
    idForm: string,
    setEmailValues: func,
    actionType: string.isRequired,
    beneficiaryData: shape({}),
};

Beneficiaries.defaultProps = {
    idForm: "",
    setEmailValues: null,
    beneficiaryData: {},
};

export default Beneficiaries;
